'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _class, _desc, _value, _class2;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactHelmet = require('react-helmet');

var _reactHelmet2 = _interopRequireDefault(_reactHelmet);

var _mobx = require('mobx');

var _reactRouter = require('react-router');

var _classAutobindDecorator = require('class-autobind-decorator');

var _classAutobindDecorator2 = _interopRequireDefault(_classAutobindDecorator);

var _common = require('../common');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

(function () {
  var enterModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.enterModule : undefined;
  enterModule && enterModule(module);
})();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
  var desc = {};
  Object['ke' + 'ys'](descriptor).forEach(function (key) {
    desc[key] = descriptor[key];
  });
  desc.enumerable = !!desc.enumerable;
  desc.configurable = !!desc.configurable;

  if ('value' in desc || desc.initializer) {
    desc.writable = true;
  }

  desc = decorators.slice().reverse().reduce(function (desc, decorator) {
    return decorator(target, property, desc) || desc;
  }, desc);

  if (context && desc.initializer !== void 0) {
    desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
    desc.initializer = undefined;
  }

  if (desc.initializer === void 0) {
    Object['define' + 'Property'](target, property, desc);
    desc = null;
  }

  return desc;
}

var __signature__ = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.default.signature : function (a) {
  return a;
};

var NotFoundPage = (0, _classAutobindDecorator2.default)(_class = (_class2 = function (_Component) {
  _inherits(NotFoundPage, _Component);

  function NotFoundPage() {
    _classCallCheck(this, NotFoundPage);

    return _possibleConstructorReturn(this, (NotFoundPage.__proto__ || Object.getPrototypeOf(NotFoundPage)).apply(this, arguments));
  }

  _createClass(NotFoundPage, [{
    key: 'onGoBackClick',
    value: function onGoBackClick() {
      _reactRouter.browserHistory.goBack();
    }
  }, {
    key: 'onGoHomeClick',
    value: function onGoHomeClick() {
      _reactRouter.browserHistory.replace('/');
    }
  }, {
    key: 'render',
    value: function render() {
      return _react2.default.createElement(
        _common.Page,
        { name: 'not-found' },
        _react2.default.createElement(_reactHelmet2.default, { title: '404' }),
        _react2.default.createElement(
          _common.Page.Content,
          null,
          _react2.default.createElement(
            'div',
            { className: 'left' },
            _react2.default.createElement(
              'div',
              { className: 'logo-wrapper' },
              _react2.default.createElement('div', { className: 'logo' })
            ),
            _react2.default.createElement('div', { className: 'shadow' })
          ),
          _react2.default.createElement(
            'div',
            { className: 'right' },
            _react2.default.createElement(
              'h1',
              null,
              'Oops! Page Not Found'
            ),
            _react2.default.createElement(
              'p',
              null,
              'We couldn\'t find the page you\'re looking for.'
            ),
            _react2.default.createElement(
              'p',
              null,
              'You can ',
              _react2.default.createElement(
                'a',
                { onClick: this.onGoBackClick },
                'go back'
              ),
              ' or ',
              _react2.default.createElement(
                'a',
                { onClick: this.onGoHomeClick },
                'go home'
              )
            )
          )
        )
      );
    }
  }, {
    key: '__reactstandin__regenerateByEval',
    // @ts-ignore
    value: function __reactstandin__regenerateByEval(key, code) {
      // @ts-ignore
      this[key] = eval(code);
    }
  }]);

  return NotFoundPage;
}(_react.Component), (_applyDecoratedDescriptor(_class2.prototype, 'onGoBackClick', [_mobx.action], Object.getOwnPropertyDescriptor(_class2.prototype, 'onGoBackClick'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, 'onGoHomeClick', [_mobx.action], Object.getOwnPropertyDescriptor(_class2.prototype, 'onGoHomeClick'), _class2.prototype)), _class2)) || _class;

var _default = NotFoundPage;
exports.default = _default;
;

(function () {
  var reactHotLoader = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.default : undefined;

  if (!reactHotLoader) {
    return;
  }

  reactHotLoader.register(NotFoundPage, 'NotFoundPage', '/app/src/components/pages/NotFoundPage.js');
  reactHotLoader.register(_default, 'default', '/app/src/components/pages/NotFoundPage.js');
})();

;

(function () {
  var leaveModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.leaveModule : undefined;
  leaveModule && leaveModule(module);
})();
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbInNyYy9jb21wb25lbnRzL3BhZ2VzL05vdEZvdW5kUGFnZS5qcyJdLCJuYW1lcyI6WyJOb3RGb3VuZFBhZ2UiLCJhdXRvQmluZE1ldGhvZHMiLCJicm93c2VySGlzdG9yeSIsImdvQmFjayIsInJlcGxhY2UiLCJvbkdvQmFja0NsaWNrIiwib25Hb0hvbWVDbGljayIsIkNvbXBvbmVudCIsImFjdGlvbiJdLCJtYXBwaW5ncyI6Ijs7Ozs7Ozs7OztBQUFBOzs7O0FBQ0E7Ozs7QUFDQTs7QUFDQTs7QUFDQTs7OztBQUVBOzs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7SUFHTUEsWSxPQURMQyxnQzs7Ozs7Ozs7Ozs7b0NBSWtCO0FBQ2ZDLGtDQUFlQyxNQUFmO0FBQ0Q7OztvQ0FHZ0I7QUFDZkQsa0NBQWVFLE9BQWYsQ0FBdUIsR0FBdkI7QUFDRDs7OzZCQUVTO0FBQ1IsYUFDRTtBQUFDLG9CQUFEO0FBQUEsVUFBTSxNQUFLLFdBQVg7QUFDRSxzQ0FBQyxxQkFBRCxJQUFRLE9BQU0sS0FBZCxHQURGO0FBRUU7QUFBQyxzQkFBRCxDQUFNLE9BQU47QUFBQTtBQUNFO0FBQUE7QUFBQSxjQUFLLFdBQVUsTUFBZjtBQUNFO0FBQUE7QUFBQSxnQkFBSyxXQUFVLGNBQWY7QUFDRSxxREFBSyxXQUFVLE1BQWY7QUFERixhQURGO0FBSUUsbURBQUssV0FBVSxRQUFmO0FBSkYsV0FERjtBQU9FO0FBQUE7QUFBQSxjQUFLLFdBQVUsT0FBZjtBQUNFO0FBQUE7QUFBQTtBQUFBO0FBQUEsYUFERjtBQUVFO0FBQUE7QUFBQTtBQUFJO0FBQUosYUFGRjtBQUdFO0FBQUE7QUFBQTtBQUFBO0FBQVc7QUFBQTtBQUFBLGtCQUFHLFNBQVMsS0FBS0MsYUFBakI7QUFBQTtBQUFBLGVBQVg7QUFBQTtBQUEwRDtBQUFBO0FBQUEsa0JBQUcsU0FBUyxLQUFLQyxhQUFqQjtBQUFBO0FBQUE7QUFBMUQ7QUFIRjtBQVBGO0FBRkYsT0FERjtBQWtCRDs7Ozs7Ozs7Ozs7RUEvQndCQyxnQixtRUFFeEJDLFksMkpBS0FBLFk7O2VBMkJZUixZOzs7Ozs7Ozs7OzswQkFsQ1RBLFkiLCJmaWxlIjoiTm90Rm91bmRQYWdlLmpzIiwic291cmNlUm9vdCI6Ii9hcHAiLCJzb3VyY2VzQ29udGVudCI6WyJpbXBvcnQgUmVhY3QsIHsgQ29tcG9uZW50IH0gZnJvbSAncmVhY3QnO1xuaW1wb3J0IEhlbG1ldCBmcm9tICdyZWFjdC1oZWxtZXQnO1xuaW1wb3J0IHsgYWN0aW9uIH0gZnJvbSAnbW9ieCc7XG5pbXBvcnQgeyBicm93c2VySGlzdG9yeSB9IGZyb20gJ3JlYWN0LXJvdXRlcic7XG5pbXBvcnQgYXV0b0JpbmRNZXRob2RzIGZyb20gJ2NsYXNzLWF1dG9iaW5kLWRlY29yYXRvcic7XG5cbmltcG9ydCB7IFBhZ2UgfSBmcm9tICcuLi9jb21tb24nO1xuXG5AYXV0b0JpbmRNZXRob2RzXG5jbGFzcyBOb3RGb3VuZFBhZ2UgZXh0ZW5kcyBDb21wb25lbnQge1xuXG4gIEBhY3Rpb25cbiAgb25Hb0JhY2tDbGljayAoKSB7XG4gICAgYnJvd3Nlckhpc3RvcnkuZ29CYWNrKCk7XG4gIH1cblxuICBAYWN0aW9uXG4gIG9uR29Ib21lQ2xpY2sgKCkge1xuICAgIGJyb3dzZXJIaXN0b3J5LnJlcGxhY2UoJy8nKTtcbiAgfVxuXG4gIHJlbmRlciAoKSB7XG4gICAgcmV0dXJuIChcbiAgICAgIDxQYWdlIG5hbWU9J25vdC1mb3VuZCc+XG4gICAgICAgIDxIZWxtZXQgdGl0bGU9JzQwNCcgLz5cbiAgICAgICAgPFBhZ2UuQ29udGVudD5cbiAgICAgICAgICA8ZGl2IGNsYXNzTmFtZT0nbGVmdCc+XG4gICAgICAgICAgICA8ZGl2IGNsYXNzTmFtZT0nbG9nby13cmFwcGVyJz5cbiAgICAgICAgICAgICAgPGRpdiBjbGFzc05hbWU9J2xvZ28nIC8+XG4gICAgICAgICAgICA8L2Rpdj5cbiAgICAgICAgICAgIDxkaXYgY2xhc3NOYW1lPSdzaGFkb3cnIC8+XG4gICAgICAgICAgPC9kaXY+XG4gICAgICAgICAgPGRpdiBjbGFzc05hbWU9J3JpZ2h0Jz5cbiAgICAgICAgICAgIDxoMT5Pb3BzISBQYWdlIE5vdCBGb3VuZDwvaDE+XG4gICAgICAgICAgICA8cD57J1dlIGNvdWxkblxcJ3QgZmluZCB0aGUgcGFnZSB5b3VcXCdyZSBsb29raW5nIGZvci4nfTwvcD5cbiAgICAgICAgICAgIDxwPllvdSBjYW4gPGEgb25DbGljaz17dGhpcy5vbkdvQmFja0NsaWNrfT5nbyBiYWNrPC9hPiBvciA8YSBvbkNsaWNrPXt0aGlzLm9uR29Ib21lQ2xpY2t9PmdvIGhvbWU8L2E+PC9wPlxuICAgICAgICAgIDwvZGl2PlxuICAgICAgICA8L1BhZ2UuQ29udGVudD5cbiAgICAgIDwvUGFnZT5cbiAgICApO1xuICB9XG59XG5cbmV4cG9ydCBkZWZhdWx0IE5vdEZvdW5kUGFnZTtcbiJdfQ==